const crypto = require('crypto-js');


/**
 * This method is to encrypt the given value by passing the string
 * 
 * @param {*} text  pass the value which need to encrypt it
 * @returns encrypted value 
 */
function encrypt(text) {

    const encrypted = crypto.AES.encrypt(text, process.env.REACT_APP_ENCRYPTION_KEY).toString();
    return encrypted;
}

/**
 * This method is used to decrypt the string by passing the encrypted value
 * 
 * @param {*} text  pass the encrypted value to decrypt it
 * @returns the decrypted value
 */
function decrypt(text) {

    const decrypted = crypto.AES.decrypt(text, process.env.REACT_APP_ENCRYPTION_KEY)
    const originalText = decrypted.toString(crypto.enc.Utf8);
    return originalText;
}

module.exports = { decrypt, encrypt };
